import Pricing8 from './Pricing8'
export default Pricing8
